// Meta Pixel (fbq) tracking helpers — safe no-ops if the pixel hasn't loaded.
export function fbTrack(event, params) {
  if (typeof window !== "undefined" && typeof window.fbq === "function") {
    window.fbq("track", event, params || {});
  }
}

export function fbTrackCustom(event, params) {
  if (typeof window !== "undefined" && typeof window.fbq === "function") {
    window.fbq("trackCustom", event, params || {});
  }
}

// Google Analytics (GA4) SPA page_view on route change.
export function gaPageView(path) {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("event", "page_view", { page_path: path, page_location: window.location.href });
  }
}

// Google Analytics (GA4) custom event (e.g. lead conversions).
export function gaEvent(event, params) {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("event", event, params || {});
  }
}
